// update along with app/lib/enums/attribute_input_type.py
const AttributeInputType = {
  LIST: 'List',
  TEXT: 'Text',
  BOOLEAN: 'Boolean',
  INTEGER: 'Integer',
  POSITIVE_INTEGER: 'Positive Integer',
  FLOAT: 'Float',
  POSITIVE_FLOAT: 'Positive Float',
  DOCUMENT: 'Document',
  MULTI_VALUE: 'Multi Value',
  TEXT_AREA: 'Text Area',
};

const ATTRIBUTE_INPUT_TYPE_LIST = [
  { value: AttributeInputType.TEXT, label: 'Text' },
  { value: AttributeInputType.LIST, label: 'List' },
  { value: AttributeInputType.BOOLEAN, label: 'Boolean' },
  { value: AttributeInputType.INTEGER, label: 'Integer' },
  { value: AttributeInputType.POSITIVE_INTEGER, label: 'Positive Integer' },
  { value: AttributeInputType.FLOAT, label: 'Float' },
  { value: AttributeInputType.POSITIVE_FLOAT, label: 'Positive Float' },
  { value: AttributeInputType.DOCUMENT, label: 'Document' },
  { value: AttributeInputType.MULTI_VALUE, label: 'Multi Value' },
  { value: AttributeInputType.TEXT_AREA, label: 'Text Area' },
];

const ATTRIBUTE_STATUS_LIST = [
  { value: true, label: 'Mandatory' },
  { value: false, label: 'Optional' },
  { value: null, label: 'Unspecified' },
];

export { ATTRIBUTE_INPUT_TYPE_LIST, ATTRIBUTE_STATUS_LIST };
export default AttributeInputType;
